var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 740 390",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #128807;\n      }\n\n      .cls-3 {\n        fill: #008;\n      }\n\n      .cls-4 {\n        fill: #f93;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag-icon-css-in"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114,0h512v130H114V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,0h740v130H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,130h740v130H0v-130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,260h740v130H0v-130Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 370,
    cy: 195,
    r: 55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 370,
    cy: 195,
    r: 48.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 370,
    cy: 195,
    r: 9.62
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 417.71,
    cy: 201.3,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370,243.13l1.65-28.88-1.65-13.75-1.65,13.75,1.65,28.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-2",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 414.46,
    cy: 213.43,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M357.54,241.49l9.07-27.46,1.96-13.71-5.15,12.85-5.88,28.32Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-3",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 408.17,
    cy: 224.31,
    r: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M345.94,236.68l15.87-24.18,5.45-12.73-8.3,11.08-13.01,25.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-4",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 399.28,
    cy: 233.19,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.97,229.03l21.58-19.25,8.56-10.89-10.89,8.56-19.25,21.58Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-3",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-5",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 388.4,
    cy: 239.47,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.32,219.06l25.83-13.01,11.08-8.3-12.73,5.45-24.18,15.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-6",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 376.26,
    cy: 242.72,
    r: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.51,207.46l28.32-5.88,12.85-5.15-13.71,1.96-27.46,9.07Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "b-4",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-7",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 363.7,
    cy: 242.71,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M321.88,195l28.87,1.65,13.75-1.65-13.75-1.65-28.88,1.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-8",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 351.57,
    cy: 239.46,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.51,182.54l27.46,9.07,13.71,1.96-12.85-5.15-28.32-5.88Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "d-2",
    "data-name": "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-3",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-5",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-9",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 340.69,
    cy: 233.17,
    r: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.32,170.94l24.18,15.87,12.73,5.45-11.08-8.3-25.83-13.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-10",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 331.81,
    cy: 224.28,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.97,160.97l19.25,21.58,10.89,8.56-8.56-10.89-21.58-19.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "b-6",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-11",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 325.53,
    cy: 213.4,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M345.94,153.32l13.01,25.83,8.3,11.08-5.45-12.73-15.87-24.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-12",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 322.28,
    cy: 201.26,
    r: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M357.54,148.51l5.88,28.32,5.15,12.85-1.96-13.71-9.07-27.46Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-4",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-7",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-13",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 322.29,
    cy: 188.7,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370,146.88l-1.65,28.88,1.65,13.75,1.65-13.75-1.65-28.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-14",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 325.54,
    cy: 176.57,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.46,148.51l-9.07,27.46-1.96,13.71,5.15-12.85,5.88-28.32Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "b-8",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-15",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 331.83,
    cy: 165.69,
    r: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M394.06,153.32l-15.87,24.18-5.45,12.73,8.3-11.08,13.01-25.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-16",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 340.72,
    cy: 156.81,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404.03,160.97l-21.58,19.25-8.56,10.89,10.89-8.56,19.25-21.58Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "d-3",
    "data-name": "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-5",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-9",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-17",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 351.6,
    cy: 150.53,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M411.68,170.94l-25.83,13.01-11.08,8.3,12.73-5.45,24.18-15.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-18",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 363.74,
    cy: 147.28,
    r: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M416.49,182.54l-28.32,5.88-12.85,5.15,13.71-1.96,27.46-9.07Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "b-10",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-19",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 376.3,
    cy: 147.29,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M418.12,195l-28.87-1.65-13.75,1.65,13.75,1.65,28.88-1.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-20",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 388.43,
    cy: 150.54,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M416.49,207.46l-27.46-9.07-13.71-1.96,12.85,5.15,28.32,5.88Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-6",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-11",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-21",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 399.31,
    cy: 156.83,
    r: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M411.68,219.06l-24.18-15.87-12.73-5.45,11.08,8.3,25.83,13.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-22",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 408.19,
    cy: 165.72,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404.03,229.03l-19.25-21.58-10.89-8.56,8.56,10.89,21.58,19.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "b-12",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-23",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 414.47,
    cy: 176.6,
    r: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M394.06,236.68l-13.01-25.83-8.3-11.08,5.45,12.73,15.87,24.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a-24",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 417.72,
    cy: 188.74,
    r: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.46,241.49l-5.88-28.32-5.15-12.85,1.96,13.71,9.07,27.46Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.8b6ef917c7600f5bb1ed91abae6315e7.svg";
export { ForwardRef as ReactComponent };